export default "__VITE_ASSET__DnLpBJib__"